// extracted by mini-css-extract-plugin
module.exports = {"Unverified":"Unverified_Unverified__2kDYQ"};